import React from 'react';
import { EUnitType } from '../@types/Enums';

export interface WheelInputConfig {
  unitType: EUnitType;
  minMetric: number;
  maxMetric: number;
  minInches: number;
  maxInches: number;
}

export const handleWheelInput = (
  e: React.WheelEvent<HTMLDivElement>,
  currentValue: string,
  updateValue: (newValue: string) => void,
  config: WheelInputConfig,
): void => {
  e.preventDefault();
  const { unitType, minMetric, maxMetric, minInches, maxInches } = config;
  const step = 1;
  let num = parseFloat(currentValue);
  if (isNaN(num)) {
    num = unitType === EUnitType.METRIC ? minMetric : minInches;
  }
  num += e.deltaY < 0 ? step : -step;
  const minValue = unitType === EUnitType.METRIC ? minMetric : minInches;
  const maxValue = unitType === EUnitType.METRIC ? maxMetric : maxInches;
  num = Math.min(maxValue, Math.max(minValue, num));
  if (unitType !== EUnitType.METRIC) {
    num = Math.round(num);
  }
  updateValue(String(num));
};
